import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GestionProveedoresComponent } from './gestion-proveedores.component';
import { AnulacionOsComponent } from './anulacion-os/anulacion-os.component';
import { NotasCreditoProveedoresComponent } from './notas-credito-proveedores/notas-credito-proveedores.component';
import { AuthGuard } from '../services/guards/login-guard.guard';

const routes: Routes = [
  {
    path: '',
    component: GestionProveedoresComponent,
    children: [
      { path: '', canActivate: [AuthGuard], component: GestionProveedoresComponent },
      { path: 'anulacion-os', canActivate: [AuthGuard], component: AnulacionOsComponent },
      { path: 'notas-credito-proveedores', canActivate: [AuthGuard], component: NotasCreditoProveedoresComponent },

      // { path: 'mantenimiento', component: MantenimientoComponent }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class GestionProveedoresRoutingModule { }
